import React from "react";
import { Card, Table, Row, Col, Statistic } from "antd";

export default function OSODTab({
  osodCustomerwise = [],
  osodExecutivewise = [],
  onAccountExecutivewise = [],
  onAccountCustomerwise = [],
  odAgewise = [],
  odCustomerwise = [],
  summary = {},
}) {
  const osAmt = summary?.OS_AMT || 0;
  const odAmt = summary?.OD_AMT || 0;
  const percent = summary?.PERCENT || 0;

  const cardStyle = {
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    background: "#fff",
    marginBottom: 16,
  };

  const title = (text, color) => (
    <span style={{ fontSize: 16, fontWeight: 600, color }}>{text}</span>
  );

  const tableProps = {
    size: "small",
    pagination: { pageSize: 10 }, // Set default page size
    bordered: false,
    scroll: { x: 400, y: 500 },
  };

  const customerOsodColumns = [
    { title: "Customer Name", dataIndex: "CardName", key: "CardName", responsive: ['xs', 'sm', 'md', 'lg', 'xl'], ellipsis: true, },
    { title: "OS Amt", dataIndex: "OS_AMT", key: "OS_AMT", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "OD Amt", dataIndex: "OD_AMT", key: "OD_AMT", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "%", dataIndex: "OD_Percentage", key: "OD_Percentage", align: "right" },
  ];

  const execOsodColumns = [
    { title: "Sales Executive", dataIndex: "SlpName", key: "SlpName", responsive: ['xs', 'sm', 'md', 'lg', 'xl'], ellipsis: true, },
    { title: "Adv Amt", dataIndex: "Adv_Amt", key: "Adv_Amt", align: "right", render: (val) => val ? Number(val).toLocaleString("en-IN") : 0, },
    { title: "OS Amt", dataIndex: "OS_AMT", key: "OS_AMT", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "OD Amt", dataIndex: "OD_AMT", key: "OD_AMT", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "%", dataIndex: "OD_Percentage", key: "OD_Percentage", align: "right" },
  ];

  const execOnAccountColumns = [
    { title: "Sales Executive", dataIndex: "SlpName", key: "SlpName" },
    { title: "Adv Balance", dataIndex: "OnAccountAmount", key: "OnAccountAmount", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const ageWiseOdColumns = [
    { title: "Sales Employee", dataIndex: "SlpName", key: "SlpName" },
    { title: "15-30 Days", dataIndex: "OD_15_30_Days", key: "OD_15_30_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Above 30 Days", dataIndex: "OD_Above_30_Days", key: "OD_Above_30_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Total", dataIndex: "Grand_Total", key: "Grand_Total", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const onAccountCustomerwiseColumns = [
    { title: "Customer", dataIndex: "CardName", key: "CardName" },
    { title: "Adv Balance", dataIndex: "AdvanceAmount", key: "AdvanceAmount", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const odCustomerwiseColumns = [
    { title: "Customer", dataIndex: "CardName", key: "CardName", responsive: ['xs', 'sm', 'md', 'lg', 'xl'], ellipsis: true, },
    { title: "15-30 Days", dataIndex: "OD_15_30_Days", key: "OD_15_30_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Above 30 Days", dataIndex: "OD_Above_30_Days", key: "OD_Above_30_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Total", dataIndex: "Grand_Total", key: "Grand_Total", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  return (
    <div className="sales-trend-tab" style={{ padding: 16 }}>
      {/* Summary Tiles */}
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Statistic title={<span style={{ color: "#000" }}>OS AMT</span>} value={osAmt} valueStyle={{ color: "#3f51b5", fontWeight: 700 }} groupSeparator="," precision={0} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Statistic title={<span style={{ color: "#000" }}>OD AMT</span>} value={odAmt} valueStyle={{ color: "#3f51b5", fontWeight: 700 }} groupSeparator="," precision={0} />
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card style={cardStyle}>
            <Statistic title={<span style={{ color: "#000" }}>OD %</span>} value={percent} suffix="%" precision={0} valueStyle={{ color: "#3f51b5", fontWeight: 700 }} />
          </Card>
        </Col>
      </Row>

      {/* 2 per row layout */}
      <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
        <Col xs={24} md={12}>
          <Card title={title("Customer Wise OS/OD %", "#c62828")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={customerOsodColumns}
              dataSource={Array.isArray(osodCustomerwise) ? osodCustomerwise : []}
              rowKey="CardName"
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ OS_AMT, OD_AMT  }) => {
                  totalQty += Number(OS_AMT) || 0;
                  totalValue += Number(OD_AMT) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title={title("Executive Wise OS/OD %", "#c62828")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={execOsodColumns}
              dataSource={Array.isArray(osodExecutivewise) ? osodExecutivewise : []}
              rowKey="SlpName"
              summary={pageData => {
                let totalAdv = 0;
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ Adv_Amt, OS_AMT, OD_AMT, }) => {
                  totalAdv += Number(Adv_Amt) || 0;
                  totalQty += Number(OS_AMT) || 0;
                  totalValue += Number(OD_AMT) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalAdv.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
        <Col xs={24} md={12}>
          <Card title={title("Executive Wise On Account", "#1565c0")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={execOnAccountColumns}
              dataSource={Array.isArray(onAccountExecutivewise) ? onAccountExecutivewise : []}
              rowKey="SlpName"
              summary={pageData => {
                let totalAdv = 0;
                pageData.forEach(({ OnAccountAmount }) => {
                  totalAdv += Number(OnAccountAmount) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalAdv.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title={title("Age Wise OD", "#1565c0")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={ageWiseOdColumns}
              dataSource={Array.isArray(odAgewise) ? odAgewise : []}
              rowKey="SlpName"
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                let totalTax = 0;
                pageData.forEach(({ OD_15_30_Days, OD_Above_30_Days, Grand_Total }) => {
                  totalQty += Number(OD_15_30_Days) || 0;
                  totalValue += Number(OD_Above_30_Days) || 0;
                  totalTax += Number(Grand_Total) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalTax.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
        <Col xs={24} md={12}>
          <Card title={title("Customer Wise Advance", "#ad1457")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={onAccountCustomerwiseColumns}
              dataSource={Array.isArray(onAccountCustomerwise) ? onAccountCustomerwise : []}
              rowKey="CardName"
              summary={pageData => {
                let totalAdv = 0;
                pageData.forEach(({ AdvanceAmount }) => {
                  totalAdv += Number(AdvanceAmount) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalAdv.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title={title("Customer Wise OD Ageing", "#ad1457")} style={cardStyle}>
            <Table
              {...tableProps}
              columns={odCustomerwiseColumns}
              dataSource={Array.isArray(odCustomerwise) ? odCustomerwise : []}
              rowKey="CardName"
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                let totalTax = 0;
                pageData.forEach(({ OD_15_30_Days, OD_Above_30_Days, Grand_Total }) => {
                  totalQty += Number(OD_15_30_Days) || 0;
                  totalValue += Number(OD_Above_30_Days) || 0;
                  totalTax += Number(Grand_Total) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalTax.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
